(function() {
  try {
    console.log('Header Scroll: init');

    var headerWrapper = document.querySelector('.header-wrapper') || document.querySelector('.section-header') || document.querySelector('.header');
    var headerInner = document.querySelector('header.header') || headerWrapper;

    if (!headerWrapper || !headerInner) {
      console.warn('Header Scroll: header element not found');
      return;
    }

    // 👇 yeh element scroll par show/hide hoga
    var headerLogoBlack = document.querySelector('.header-logo-black');
    if (headerLogoBlack) {
      headerLogoBlack.style.display = 'none'; // default transparent mode
    }

    function applyScrolledState(on) {
      if (on) {
        // background white mode
        headerWrapper.classList.add('scrolled');
        headerInner.classList.add('scrolled');
        var section = document.querySelector('.section-header');
        if (section && !section.classList.contains('scrolled-past-header')) section.classList.add('scrolled-past-header');
        try { headerWrapper.style.setProperty('--header-foreground', '#111111'); } catch(e){}

        var activeMenuItem = document.querySelector('span.header__active-menu-item');
        if (activeMenuItem) activeMenuItem.style.color = 'black';

        // 👇 background white par logo show karo
        if (headerLogoBlack) headerLogoBlack.style.display = 'block';
      } else {
        // background transparent mode
        headerWrapper.classList.remove('scrolled');
        headerInner.classList.remove('scrolled');
        var section2 = document.querySelector('.section-header');
        if (section2 && section2.classList.contains('scrolled-past-header')) section2.classList.remove('scrolled-past-header');
        try { headerWrapper.style.setProperty('--header-foreground', '#ffffff'); } catch(e){}

        var activeMenuItem2 = document.querySelector('span.header__active-menu-item');
        if (activeMenuItem2) activeMenuItem2.style.color = 'white';

        // 👇 background transparent par logo hide karo
        if (headerLogoBlack) headerLogoBlack.style.display = 'none';
      }
    }

    function setScrolled(on) {
      applyScrolledState(on);
    }

    var main = document.querySelector('main#MainContent, main, #MainContent, .main-content');
    var sentinel = document.createElement('div');
    sentinel.className = 'header-scroll-sentinel';
    sentinel.style.width = '1px';
    sentinel.style.height = '1px';
    sentinel.style.position = 'absolute';
    sentinel.style.top = '0';
    sentinel.style.left = '0';

    if (main && main.firstChild) {
      main.insertBefore(sentinel, main.firstChild);
    } else if (main) {
      main.appendChild(sentinel);
    } else {
      document.body.insertBefore(sentinel, document.body.firstChild);
    }

    function safeObserverInit() {
      var headerHeight = (headerWrapper && headerWrapper.offsetHeight) ? headerWrapper.offsetHeight : 70;

      var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          setScrolled(!entry.isIntersecting);
        });
      }, {
        root: null,
        threshold: 0,
        rootMargin: '-' + headerHeight + 'px 0px 0px 0px'
      });

      io.observe(sentinel);

      window.addEventListener('scroll', function() {
        if (window.scrollY > headerHeight + 10) setScrolled(true);
        else setScrolled(false);
      }, {passive: true});

      setTimeout(function() {
        if (window.scrollY > headerHeight + 10) setScrolled(true);
        else setScrolled(false);
      }, 50);

      console.log('Header Scroll: observer initialized (headerHeight=' + headerHeight + ')');
    }

    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      setTimeout(safeObserverInit, 30);
    } else {
      document.addEventListener('DOMContentLoaded', safeObserverInit);
    }
  } catch (e) {
    console.error('Header Scroll error:', e);
  }
})();
